import { render, staticRenderFns } from "./SchedaFattura.vue?vue&type=template&id=1d839eae&scoped=true&"
import script from "./SchedaFattura.vue?vue&type=script&lang=js&"
export * from "./SchedaFattura.vue?vue&type=script&lang=js&"
import style0 from "./SchedaFattura.vue?vue&type=style&index=0&id=1d839eae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d839eae",
  null
  
)

export default component.exports